module.exports = __webpack_public_path__ + "img/rd-refill-icon-no-text.ab9401de.png";